import assign from 'lodash/assign';

import { VideoSliderServiceModule } from 'components/videoSlider/videoSlider.service';
import { TrialServiceModule, NOT_TRIAL } from 'components/trial/trial.service';

import './videoHeaderButton.scss';

export const VideoHeaderButtonModule = angular
    .module('app.components.videoSlider.videoHeaderButton', [
        VideoSliderServiceModule,
        TrialServiceModule
    ]).component('videoHeaderButton', {
        template: `
        <md-button ng-if="$ctrl.isTrialAccount"
            ng-click="$ctrl.openVideoSlider()"
            class="video-slider-header-button">

            <md-icon>play_circle_outline</md-icon>
            <span hide-xs>Watch the Video</span>
        </md-button>
        `,
        bindings: {
            videoLink: '<'
        },
        controller: class VideoHeaderButtonController {
            constructor(
                videoSliderService,
                trialService
            ) {
                'ngInject';

                assign(this, {
                    videoSliderService,
                    trialService,
                    isTrialAccount: true
                });
            }

            $onInit() {
                this.trialService.getTrialStatus()
                    .then(status => this.isTrialAccount = status !== NOT_TRIAL);
            }

            openVideoSlider() {
                this.videoSliderService.openSlider(this.videoLink);
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/videoSlider/videoHeaderButton.component.js